var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('notifications'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('global-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }